<!-- 首页 -->
<template>
  <div class="home">
    <div class="contLeft">
      <div class="initialLogin" v-if="!group_status">
        <div class="initialLeft">
          <img
            src="../../assets/new/tj_a2.png"
            alt=""
            style="
              vertical-align: middle;
              width: 20px;
              height: 20px;
              margin-top: -3px;
              margin-right: 10px;
            "
          />
          注意！！初次登录请先完善机构详情相关信息。
        </div>
        <div class="initialRight" @click="toInstitutions">去完善</div>
      </div>
      <div v-if="statisticalList && statisticalList.length > 0" class="statisticalBox">
        <h1>
          统计指标
          <el-select
            v-if="appOptions.length > 1"
            size="small"
            v-model="app_keys"
            clearable
            @change="appKeysChange"
            style="
              vertical-align: middle;
              margin-top: -3px;
              margin-left: 10px;
              width: 150px;
            "
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in appOptions"
              :key="item.app_key"
              :label="item.app_key_name"
              :value="item.app_key"
            >
            </el-option>
          </el-select>

          <el-popover placement="top-start" width="500" trigger="hover">
            <div v-html="selfnumber" style="white-space: pre-line"></div>
            <i class="el-icon--right questionIcon" slot="reference"></i>
          </el-popover>
        </h1>
        <div class="statisticalListBox">
          <div
            class="statisticalItem"
            :class="item.label == 'fee' ? 'feeItem' : ''"
            v-for="(item, index) in statisticalList"
            :key="index"
            @click="skip(item, index)"
            :style="{
              background: 'url(' + item.pic + ')' + ' ' + 'no-repeat',
              backgroundSize: '100% 100%',
            }"
          >
            <div class="name">
              {{ item.name }}
              <el-button
                type="primary"
                v-if="item.label == 'fee'"
                size="mini"
                @click.stop="Recharge"
                style="display: inline-block; margin-left: 10px"
                >充值</el-button
              >
            </div>
            <div class="value">
              <span> 
                {{ item.value }}
              </span>
              <div v-if="item.label == 'fee'" style="display: inline-block">
                <el-popover placement="left-start" width="500" trigger="hover">
                  <div style="white-space: pre-line">
                    <h3>帐户余额说明：</h3>
                    <p style="margin-top: 10px; color: #333">
                      总计：
                      <span style="color: red">
                        {{ fee }}（可用充值金额+可用赠送金额）</span
                      >
                    </p>
                    <p style="margin-top: 10px; color: #333">
                      1、可用充值金额：
                      <span style="color: red">
                        {{ chongzhi_surplus_fee }}
                      </span>

                      <span v-if="dongjie.dongjie_order_fee > 0">
                        (已冻结金额：<span style="color: red">{{
                          dongjie.dongjie_order_fee
                        }}</span
                        >)
                      </span>
                    </p>
                    <p style="margin-top: 10px; color: #333">
                      2、可用赠送金额：
                      <span style="color: red">{{
                        give_fee_info.surplus_give_fee_total
                      }}</span>

                      <span v-if="dongjie.dongjie_give_fee > 0">
                        (已冻结金额：<span style="color: red">{{
                          dongjie.dongjie_give_fee
                        }}</span
                        >)
                      </span>
                    </p>

                    <div
                      v-if="
                        give_fee_info.give_list &&
                        give_fee_info.give_list.length > 0
                      "
                    >
                      <div
                        v-for="(item, index) in give_fee_info.give_list"
                        :key="index"
                        style="margin-top: 10px; color: #333"
                      >
                        其中
                        <span style="color: red">
                          {{ item.surplus_give_fee }}
                        </span>
                        使用期效为
                        <span style="color: red">
                          {{ item.use_start_date }}
                          ~
                          {{ item.use_end_date }}
                        </span>
                        可用范围为
                        <span
                          style="color: red"
                          v-for="(itemA, indexA) in item.use_type_names"
                          :key="indexA"
                        >
                          {{ itemA
                          }}<i
                            v-if="indexA + 1 < item.use_type_names.length"
                            style="display: inline-block"
                            >,</i
                          >
                        </span>
                      </div>
                    </div>
                    <p style="margin-top: 10px; color: #333">
                      【注意：系统会优先扣除充值金额，充值金额扣除完毕，才会扣除赠送金额】
                    </p>
                  </div>
                  <i class="el-icon--right questionIcon2" slot="reference"></i>
                </el-popover>
              </div>
            </div>
            <div v-if="item.label == 'fee'" class="dongjie">
              (冻结金额 {{ dongjie.dongjie_fee_total }})
              <el-popover placement="left-start" width="500" trigger="hover">
                <div style="white-space: pre-line">
                  <h3>冻结金额说明：</h3>
                  <p>
                    1、给学员开通订单，如果学员未激活不会正式扣除费用，但会冻结相应的金额。
                  </p>
                  <p>
                    2、如需解除金额冻结，可在订单列表—筛选“订单状态”为已开通的订单（未激活），点击取消订单，即可解除对应订单的冻结金额。
                  </p>
                  <p
                    style="
                      text-align: right;
                      font-size: 15px;
                      font-weight: bold;
                      margin-top: 15px;
                      color: #000;
                    "
                  >
                    冻结总计：<span style="color: red">{{
                      dongjie.dongjie_fee_total
                    }}</span>
                    （充值金额冻结<span style="color: red">{{
                      dongjie.dongjie_order_fee
                    }}</span
                    >+赠送金额冻结<span style="color: red">{{
                      dongjie.dongjie_give_fee
                    }}</span
                    >）
                  </p>
                </div>
                <i class="el-icon--right questionIcon2" slot="reference"></i>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="featureBox">
        <h1>热门功能</h1>
        <div class="featureCont">
          <div v-if="role != 'salespersonr' && role != 'outboundcall'" class="featureItem">
            <div class="itemTop">
              <img
                class="topLeft"
                src="../../assets/new/feature_a1.png"
                alt=""
                style="
                  vertical-align: middle;
                  width: 53px;
                  height: 53px;
                  margin-top: -3px;
                  margin-right: 10px;
                "
              />
              <div class="topRight">
                <div class="itemName">开通商品</div>
                <div class="itemValue">选择商品类型 单个或批量开通</div>
              </div>
            </div>
            <div class="itemBottom">
              <div v-if="senioriupShow" class="btn" @click="btn1">视频</div>
              <div v-if="senioriupShow" class="btn" @click="btn2">
                会员

                <img
                  src="../../assets/new/tj_a1.png"
                  alt=""
                  style="
                    width: 36px;
                    height: 21px;
                    position: absolute;
                    right: -9px;
                    top: -9px;
                  "
                />
              </div>
              <div
                v-if="is_show_package && adultscollegeShow"
                class="btn"
                @click="btn3"
              >
                套餐
              </div>
            </div>
          </div>
          <div v-if="role != 'outboundcall'" class="featureItem" @click="zsxgj">
            <div class="itemTop">
              <img
                class="topLeft"
                src="../../assets/new/feature_a2.png"
                alt=""
                style="
                  vertical-align: middle;
                  width: 53px;
                  height: 53px;
                  margin-top: -3px;
                  margin-right: 10px;
                "
              />
              <div class="topRight">
                <div class="itemName">
                  招生小工具

                  <!-- <img
                    class="img"
                    src="../../assets/new/tj_a3.png"
                    alt=""
                    style="
                      width: 40px;
                      height: 24px;
                      position: absolute;
                      right: -5px;
                      top: -5px;
                    "
                  /> -->
                </div>
                <div class="itemValue">让学员完成自主注册</div>
              </div>
            </div>
            <div class="itemBottom"></div>
          </div>
          <div v-if="role != 'nstitutionalteacher' && role != 'salespersonr' && is_show_big_data" class="featureItem" @click="whpt">
            <div class="itemTop">
              <img
                class="topLeft"
                src="../../assets/new/feature_a3.png"
                alt=""
                style="
                  vertical-align: middle;
                  width: 53px;
                  height: 53px;
                  margin-top: -3px;
                  margin-right: 10px;
                "
              />
              <div class="topRight">
                <div class="itemName">外呼平台</div>
                <div class="itemValue">大数据扩客 智能呼叫</div>
              </div>
            </div>
            <div class="itemBottom"></div>
          </div>

          <div  class="featureItem">
            <div class="itemTop"> 
              <QrCode3 
                v-if="myUserInfo && myUserInfo.group && myUserInfo.group.code"
                :id="myUserInfo.group.code"
                :experienceId="'exp_' + myUserInfo.group.code" 
                :pictureId="'picture_' + myUserInfo.group.code" 
                :codeUrl="myUserInfo.app_down_url"
                :code="myUserInfo.group.code"
              />   
            </div>
            <img
              class="img"
              src="../../assets/new/tj_a3.png"
              alt=""
              style="
                width: 40px;
                height: 24px;
                position: absolute;
                right: 35px;
                top: -5px;
              "
            />
          </div>

          <div v-if="is_open_xcx == '1'" class="featureItem">
            <div class="itemTop"> 
              <QrCode5  
                :id="invite_code"
                :experienceId="'exp_' + invite_code" 
                :pictureId="'picture_' + invite_code" 
                :codeUrl="codeUrl"
                :code="invite_code"
                :is_open_xcx="is_open_xcx"
              />    
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contRight">
      <div class="rightH4">
        <div class="rightH4Title">公告</div>
        <div class="rightH4Cont"> 
            <div 
              class="item"
              v-for="(item, index) in noticeList"
              :key="index"
              @click="noticeClick(item)"
            >
              <el-tag
                effect="plain" 
                style="margin-right: 10px;"
                >
                {{ item.type_name }}
              </el-tag>
              <span class="title">{{ item.title }}</span>
              <span v-if="item.is_new == 1" class="new">new</span> 
            </div> 
        </div>
        <div class="rightH4Bottom" style="text-align: right;">
          <el-button type="text" @click="noticeMore()">更多...</el-button>
        </div>
      </div>

      <div v-if="role == 'admin' || role == 'generaladministrato'" class="rightH3">
        <div class="rightH3Title">使用说明</div>
        <div class="rightH3Cont">
          <div class="rightH3Item">
            <img
              class="itemLeft"
              src="../../assets/new/tj_a6.png"
              alt=""
              style="
                vertical-align: middle;
                width: 24px;
                height: 188px;
                margin-right: 18px;
              "
            />
            <div class="itemRight">
              <div class="title">完善机构信息</div>
              <div class="nodulus" @click="nodulusClick(1)">机构设置</div>
              <div class="cont">联系方式、微信二维码、地址等</div>
              <div class="nodulus" @click="employee()">员工管理</div>
              <div class="cont">录入员工/选择角色</div>
            </div>
          </div>
          <div class="rightH3Item">
            <img
              class="itemLeft"
              src="../../assets/new/tj_a7.png"
              alt=""
              style="
                vertical-align: middle;
                width: 24px;
                height: 254px;
                margin-right: 18px;
              "
            />
            <div class="itemRight">
              <div class="title">给学员开课</div>
              <div class="nodulus" @click="nodulusClick(2)">添加学员</div>
              <div class="cont">方式一：手动录入学员</div>
              <div class="recommend" @click="signUp()">
                方式二：通过邀请码自动录入学员
                【发二维码给学员下载并注册APP】 
              </div>
              <div class="nodulus" @click="commodity()">开通商品</div>
              <div class="cont">手动开通</div>
              <div v-if="is_study_card" class="recommend" @click="liberal()">
                卡密开通
                <img
                  src="../../assets/new/tj_a1.png"
                  alt=""
                  style="
                    width: 36px;
                    height: 21px;
                    position: absolute;
                    right: 130px;
                    top: -15px;
                  "
                />
              </div>
            </div>
          </div>
          <div class="rightH3Item">
            <img
              class="itemLeft"
              src="../../assets/new/tj_a8.png"
              alt=""
              style="
                vertical-align: middle;
                width: 24px;
                height: 250px;
                margin-right: 18px;
              "
            />
            <div class="itemRight">
              <div class="title">招生推广</div>
              <div class="nodulus" @click="miniProgram()">小程序推广</div>
              <div class="cont">通过小程序招生引流</div>
              <img
                class="pic"
                src="../../assets/new/tj_a9.png"
                alt=""
                style="
                  width: 90px;
                  height: 90px;
                  padding-left: 14px;
                  padding-bottom: 12px;
                "
              />
              <div v-if="is_study_card" class="nodulus" @click="drainage()">
                卡密引流
              </div>
              <div v-if="is_study_card" class="cont">
                快捷开通商品，学员激活即可用
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="role == 'admin' || role == 'generaladministrato'" class="rightH2">
        <div class="rightH2Top">
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a5.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            技术对接和充值:
            {{ contacts }}
          </div>
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a4.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            联系方式：
            {{ contacts_moblie }}
          </div>
        </div>
        <div class="rightH2Bottom">
          <div class="rightH2b">
            <img
              class="img"
              :src="quickresponse"
              alt=""
              style="width: 100%; height: 100%; margin-bottom: 7px"
            />
            <div>微信咨询 扫码联系</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="imgShow" width="415px">
      <img class="img" :src="group_img" alt="" style="width: 100%" />

      <el-button
        type="success"
        @click="downloadImg"
        style="margin-top: 20px; width: 100%"
        >下载宣传图片</el-button
      >

      <div style="margin-top: 20px; width: 100%; text-align: center">
        下载后可分享至微信群或朋友圈
      </div>
    </el-dialog>

    <el-dialog :visible.sync="RechargeShow" width="400px">
      <div class="RechargeBox">
        <div class="rightH2Top">
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a5.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            技术对接和充值:
            {{ contacts }}
          </div>
          <div class="rightH2a">
            <img
              class="topLeft"
              src="../../assets/new/tj_a4.png"
              alt=""
              style="
                vertical-align: middle;
                width: 20px;
                height: 20px;
                margin-top: -3px;
                margin-right: 10px;
              "
            />
            联系方式：
            {{ contacts_moblie }}
          </div>
        </div>
        <div class="rightH2Bottom">
          <div class="rightH2b">
            <img
              class="img"
              :src="quickresponse"
              alt=""
              style="width: 100%; height: 100%; margin-bottom: 7px"
            />
            <div>微信咨询 扫码联系</div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import goodsApi from "@/api/goods.js";
import { clearObj, copyToClip } from "@/utils/index.js";
import html2canvas from "html2canvas"; 
import QrCode3 from "@/components/QrCode3.vue";
import QrCode5 from "@/components/QrCode5.vue";
import * as Utils from "@/utils";
export default {
  name: "Home",
  components: { QrCode3, QrCode5 },
  data() {
    return {
      list: [
        {
          label: "student_total",
          name: "累计新增学员",
          value: 0,
          path: "/studentManage",
        },
        {
          label: "order_total",
          name: "累计新增订单",
          value: 0,
          path: "/orderList",
        },
        {
          label: "sale",
          name: "累计销售额",
          value: "¥0",
          path: "/orderList",
        },
        {
          label: "fee",
          name: "账户余额",
          value: "¥0",
          path: "/financialManage",
        },
      ],
      statisticalList: [],
      shareLinkData: "",
      imgShow: false,
      group_img: "",
      group_status: 1,
      contacts: "",
      contacts_moblie: "",
      quickresponse: "",
      group_id: "",
      app_keys: "",
      appOptions: [],
      is_show_marketing: 0,
      is_show_task: 0,
      is_show_package: 0,
      is_show_big_data: 0,
      selfnumber: "",
      senioriupShow: false,
      adultscollegeShow: false,
      is_study_card: 0,
      RechargeShow: false,
      give_fee_info: {},
      chongzhi_surplus_fee: "",
      fee: "",
      dongjie: {},
      noticeList:[],
      noticePopupShow: false,
      noticeData: [],
      noticeIndex: 0,
      myUserInfo: {}, 
      invite_code: "",
      xcx_img: "",
      is_open_xcx: "", 
      role: "",
      codeUrl: ""  
    };
  },
  watch: {
    noticePopupShow(newVal, oldVal) {
      console.log("newVal---", newVal, this.noticeIndex, this.noticeLength, this.noticeIndex + 1 < this.noticeLength); 
      if (!newVal) { 
        if(this.noticeIndex + 1 < this.noticeLength && this.noticeData[this.noticeIndex].type_name){
          setTimeout(() => {
            this.noticeIndex++
            this.noticePopupShow = true
            this.resetExamType(this.noticeData[this.noticeIndex].id)
          }, 500);
        }
      }
    },
  },   
  created() { 
    this.role = this.$store.state.user.userInfo.role
    // if(localStorage.getItem('myUserInfo')){
    //   this.myUserInfo = JSON.parse(localStorage.getItem('myUserInfo')) 
    //   console.log("myUserInfo---", this.myUserInfo)
    // } 

    // if(localStorage.getItem("invite_code")){
    //   const invite_code = localStorage.getItem("invite_code")
    //   this.invite_code = invite_code.toString()
    // }
    // if(localStorage.getItem("xcx_img")){
    //   const xcx_img = localStorage.getItem("xcx_img")
    //   this.xcx_img = xcx_img.toString()
    // }
    // if(localStorage.getItem("is_open_xcx")){
    //   const is_open_xcx = localStorage.getItem("is_open_xcx")
    //   this.is_open_xcx = is_open_xcx.toString()
    // }
    console.log("xcx_img---", this.xcx_img)
 
    this.homeList();
    this.statisticalListShow() 
    this.getMe(); 
    this.getNoticeList(); 
    this.getDic();
    this.getInfoToName();
    this.getTobHideMenu();
  },
  computed: {
    isSalespersonr() {
      //  this.$store.state.user.userInfo.role,this.$store.state.user.userInfo.role == 'salespersonr');
      return this.$store.state.user.userInfo.role == "salespersonr";
    }, 
  },
  methods: {
    statisticalListShow(){
      // 高级管理员 admin
      // 普通管理员 generaladministrato
      // 单位老师  nstitutionalteacher
      // 招生专员 salespersonr
      // 外呼专员 outboundcall
      if (this.role == "nstitutionalteacher"){
        this.statisticalList = [ 
          {
            label: "student_total",
            name: "学员数量",
            value: "",
            path: "/studentManage",
            pic: require("../../assets/new/target_a4.png"),
          },
          {
            label: "order_total",
            name: "订单数量",
            value: "",
            path: "/orderList",
            pic: require("../../assets/new/target_a2.png"),
          },
        ]
      } else if (this.role == "salespersonr"){
        this.statisticalList = [ 
          {
            label: "student_total",
            name: "学员数量",
            value: "",
            path: "/studentManage",
            pic: require("../../assets/new/target_a4.png"),
          }, 
        ]
      } else if (this.role == "outboundcall"){
        this.statisticalList = []
      } else {
        this.statisticalList = [
          {
            label: "student_total",
            name: "学员数量",
            value: "",
            path: "/studentManage",
            pic: require("../../assets/new/target_a4.png"),
          },
          {
            label: "order_total",
            name: "订单数量",
            value: "",
            path: "/orderList",
            pic: require("../../assets/new/target_a2.png"),
          },
          {
            label: "fee",
            name: "账户机构余额",
            value: "",
            path: "/financialManage",
            pic: require("../../assets/new/target_a5.png"),
          },
          {
            label: "tc_money",
            name: "推广收益金额",
            value: "",
            path: "/institutionalIncomeDetail",
            pic: require("../../assets/new/target_a3.png"),
          },
          {
            label: "sale",
            name: "订单金额",
            value: "",
            path: "/orderList",
            pic: require("../../assets/new/target_a1.png"),
          },
        ]
      } 
    },
    async getMe() {
      const res = await commonApi.tobMe()
      if (res.code === 200) {
        this.myUserInfo = res.data 
        localStorage.setItem("invite_code", res.data.invite_code)
        
        this.invite_code = res.data.group.code
        this.group_id = res.data.group.id 
        setTimeout(() => {
          this.getActivityXcxCode() 
        }, 1000)
      }
    },
    getWxcodeEnvVersion(){
      if (process.env.NODE_ENV == "production") {
          return "release";
      } else {
          return "trial";
      }
    },
    getActivityXcxCode(){ 
      var XcxData = {
        scene: this.invite_code,
        page: "pages/examIndex",
        width: "280",
        check_path: false,
        is_hyaline: true,
        env_version: this.getWxcodeEnvVersion()
      }
      commonApi.getActivityXcxCode({ 
        data:  JSON.stringify(XcxData), 
        type: '3', 
        invite_code: this.invite_code,
        is_oss_url: 1,
        group_id: this.group_id
      }).then((res) => {
        console.log("getActivityXcxCode", res.data.oss_url); 
        this.codeUrl = res.data.oss_url 
      });
    }, 
    getNoticeList(){
      commonApi.getNoticeList({limit: 4, page: 1, total: 0,  }).then((res) => {
        console.log("getNoticeList", res.data);
        this.noticeList = res.data.list;

        this.typeOptions = res.data.type_list;
      });
    },
    noticeClick(e){
       console.log("noticeClick",e)
       this.$router.push({
        path: "/noticeDetail",
        query: {
          id: e.id,
        },
      });
    },
    noticeMore(){
      console.log("noticeMore")
      this.$router.push({
        path: "/noticeList", 
      });
    },
    Recharge() {
      this.RechargeShow = true;
    },
    getDic() {
      commonApi.getInfoToName({ name: "nailingreminder" }).then((res) => {
        console.log("nailingreminder", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "bexpositorycase") {
              console.log("bexpositorycase", item.value);
              this.selfnumber = item.value;
            }
          });
        }
      });
    },
    commodity() {
      // senioriupShow: false, 高职单招考试

      if (this.senioriupShow) {
        this.$router.push({
          path: "/memberManage",
        });
      } else {
        this.$router.push({
          path: "/setMealList",
        });
      }
    },
    miniProgram() {
      // 小程序推广
      this.$router.push({
        path: "/extendTool",
        query: {
          activeName: "first",
        },
      });
    },
    drainage() {
      // 卡密引流
      this.$router.push({
        path: "/cardManage",
        // query: {
        //   activeName: "first",
        // },
      });
    },
    signUp() {
      // 扫码报名或直接购课
      this.$router.push({path: "/appDownload"}); 
    },
    liberal() {
      // 卡密开通或链接支付开通
      this.$router.push({
        path: "/cardManage",
        // query: {
        //   activeName: "third",
        // },
      });
    },
    employee() {
      // 员工管理
      this.$router.push({
        path: "/employeesManage",
        query: {
          activeName: "third",
        },
      });
    },
    zsxgj() {
      this.$router.push({
        path: "/extendTool",
        query: {
          activeName: "third",
        },
      });
    },
    whpt() {
      this.$router.push({
        path: "/callPhone",
        //   query: {
        //     activeName: "third",
        //   },
      });
    },
    nodulusClick(e) {
      if (e == 1) {
        // 机构设置
        this.$router.push({
          path: "/institutionsOption",
        });
      } else if (e == 2) {
        // 新增学员
        this.$router.push({
          path: "/studentManage",
        });
      }
    },
    toInstitutions() {
      this.$router.push({
        path: "/institutionsOption",
      });
    },
    btn1() {
      this.$router.push({
        path: "/courseManage",
      });
    },
    btn2() {
      this.$router.push({
        path: "/memberManage",
      });
    },
    btn3() {
      this.$router.push({
        path: "/setMealList",
      });
    },
    getTobHideMenu() {
      goodsApi.getTobHideMenu().then((res) => {
        if (res.code === 200) {
          console.log("getTobHideMenu", res.data);
          this.is_show_marketing = res.data.is_show_marketing;
          this.is_show_task = res.data.is_show_task;
          this.is_show_package = res.data.is_show_package;
          this.is_show_big_data = res.data.is_show_big_data;
          this.is_study_card = res.data.is_study_card;
        }
      });
    },
    appKeysChange(e) {
      console.log("appKeysChange", e);
      this.app_keys = e;
      this.homeList();
    },
    getInfoToName() {
      commonApi.getInfoToName({ name: "orderamountlimit" }).then((res) => {
        console.log("1----", res.data);
        if (res.data && res.data.length > 0) {
          res.data.forEach((item) => {
            if (item.key == "contacts") {
              this.contacts = item.value;
              localStorage.setItem("contacts", this.contacts) 
            } else if (item.key == "contacts_moblie") {
              this.contacts_moblie = item.value;
              localStorage.setItem("contacts_moblie", this.contacts_moblie) 
            } else if (item.key == "quickresponse") {
              this.quickresponse = item.value;
              localStorage.setItem("quickresponse", this.quickresponse) 
            }
          });
        }
      });
    },

    downloadCanvasIamge(selector, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");

        // 生成一个a元素
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");

        // 将a的download属性设置为我们想要下载的图片名称，若name不存在则使用‘下载图片名称’作为默认名称
        a.download = name || "下载图片名称";
        // 将生成的URL设置为a.href属性
        a.href = url;
        // 触发a的单击事件
        a.dispatchEvent(event);
      };

      image.src = document.querySelector(selector).src;
    },

    toPerfect(e) {
      console.log("toPerfect", e);
      if (e == 1) {
        this.$router.push({
          path: "/institutionsOption",
        });
      } else if (e == 2) {
        this.$router.push({
          path: "/studentManage",
        });
      } else if (e == 3) {
        if (
          localStorage.getItem("is_show_package") == 1 &&
          localStorage.getItem("is_show_vip") == 0
        ) {
          this.$router.push({
            path: "/setMealList",
          });
        } else if (
          localStorage.getItem("is_show_package") == 0 &&
          localStorage.getItem("is_show_vip") == 1
        ) {
          this.$router.push({
            path: "/memberManage",
          });
        } else if (
          localStorage.getItem("is_show_package") == 1 &&
          localStorage.getItem("is_show_vip") == 1
        ) {
          this.$router.push({
            path: "/memberManage",
          });
        }
      }
    },
    downloadImg() {
      var query = { group_id: this.group_id };
      const newUrl = process.env.VUE_APP_SERVE + "/api/v1/tob/downGroupImg";
      const url = Utils.getGetUrl(newUrl, "get", query);
      console.log("downloadImg", url);
      window.open(url, "_blank");
    },
    lookOver3() {
      this.$router.push({
        path: "/recruitList",
      });
    },
    lookOver2() {
      // 查看
      // window.open(this.shareLinkData, "_blank");
      this.imgShow = true;
    },
    lookOver() {
      // 查看
      // window.location.href = this.shareLinkData;
      window.open(this.shareLinkData, "_blank");
    },
    shareLink() {
      // 复制分享链接
      this.$message.success("复制成功");
      copyToClip(`${this.shareLinkData}`);
    },

    async homeList() {
      const res = await commonApi.homeData({ app_keys: this.app_keys });
      if (res.code == 200) {
        this.is_open_xcx = res.data.is_open_xcx.toString() 

        let _obj = res.data;
        let _arr = Object.keys(_obj);
        this.list.forEach((item, index) => {
          _arr.forEach((_item, _index) => {
            if (item.label === _item) {
              this.list[index].value = _obj[_item];
            }
          });
        });

        this.statisticalList.forEach((item, index) => {
          _arr.forEach((_item, _index) => {
            if (item.label === _item) {
              if (_item == "fee" || _item == "tc_money" || _item == "sale") {
                this.statisticalList[index].value = "¥" + _obj[_item];
              } else {
                this.statisticalList[index].value = _obj[_item];
              }

              if (_item == "fee") {
                console.log("item---", item.label, _item, _obj[_item]);
                this.statisticalList[index].dongjie_fee_total =
                  _obj["dongjie_fee_total"];
              }
            }
          });
        });

        this.give_fee_info = res.data.give_fee_info;
        this.chongzhi_surplus_fee = res.data.chongzhi_surplus_fee;
        this.fee = res.data.fee;
        console.log("give_fee_info", this.give_fee_info);
        this.shareLinkData = res.data.web_domain;
        this.group_img = res.data.group_img;
        this.group_status = res.data.group_status;
        this.group_id = res.data.group_id;
        

        this.dongjie = res.data.dongjie;
        this.dongjie.fee = res.data.fee;
        console.log("dongjie", this.dongjie);

        this.appOptions = res.data.menu;

        this.senioriupShow = false;
        this.adultscollegeShow = false;
        res.data.menu.forEach((item, index) => {
          if (item.app_key == "senioriup") {
            // 高职单招考试
            this.senioriupShow = true;
          }
          if (item.app_key == "adultscollege") {
            // 成人高考
            this.adultscollegeShow = true;
          }
        });
        console.log("senioriupShow", res.data.menu, this.senioriupShow);
      } else {
        this.$message.error(res.message);
      }
    },
    skip(_item, index) {
      if (index == 3 && this.isSalespersonr) {
        this.$message.error("暂无权限！");
        return;
      }
      this.$router.push({
        path: _item.path,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  padding: 16px 32px 16px 16px;
  box-sizing: border-box;
  // overflow: auto;
  overflow-x: initial;
  display: flex;
  justify-content: space-between;
  min-width: 1200px;
  background: #f7f8fb;
  .contLeft {
    width: 75%;
    min-width: 1020px;
    margin-right: 20px;
    .list {
      margin-top: 10px;
      display: flex;
      .listItem {
        flex: 1;
        margin: 0 5px;
        padding: 10px 0;
        text-align: center;
        background-color: #ccc;
        border-radius: 10px;
        & > div {
          line-height: 40px;
          cursor: pointer;
        }
        .value {
          font-size: 24px;
          color: #333;
        }
        .name {
          color: #999;
        }
        .skip {
          text-align: right;
          padding: 0 10px;
          color: #303133;
          font-size: 14px;
          line-height: 30px;
        }
      }
    }
    .recommendBox {
      display: block;
      margin-top: 20px;
      .recommend {
        margin-top: 20px;
        display: flex;
        .recommendItem {
          margin: 0 5px;
          padding: 15px;
          text-align: center;
          border: 1px solid #ddd;
          width: 360px;
          .itemTop {
            display: flex;
            justify-content: space-between;

            .itemTopL {
              width: 20%;
              // height: 40px;
              // background-color: #ddd;
              .img {
                width: 100%;
                // height: 40px;
              }
            }
            .itemTopR {
              width: 75%;
              .title {
                font-size: 15px;
                color: #333;
                font-weight: bold;
                text-align: left;
                line-height: 120%;
              }
              .cont {
                font-size: 14px;
                color: #434446;
                text-align: left;
                margin-top: 5px;
                .contItem {
                  margin-right: 10px;
                }
              }
              .lookOver3 {
                margin-top: 20px;
                text-align: left;
              }
            }
          }
          .itemBt {
            justify-content: flex-end;
            display: flex;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .contRight {
    width: 22%;
    min-width: 360px;
    // border: 1px solid #ddd;
    // padding: 1%;
    display: block;
    .rightH1 {
      border: 1px solid #ddd;
      padding: 10px;
      .rightH1Item {
        justify-content: space-between;
        display: flex;
        padding: 10px 0;
        .rightH1ItemL {
          line-height: 30px;
        }
        .rightH1ItemR {
          line-height: 30px;
          color: #409eff;
          cursor: pointer;
        }
      }
    }
    .rightH2 {
      margin-top: 20px;
      background: #ffffff;
      border-radius: 8px;
      padding-bottom: 40px;
      .rightH2Top {
        padding: 40px 0 0 50px;
        // padding-bottom: 25px;
        // border-bottom: 1px solid #ddd;
        .rightH2a {
          line-height: 180%;
          font-size: 18px;
          color: #465069;
        }
      }
      .rightH2Bottom {
        // padding-top: 10px;
        margin-top: 25px;
        .rightH2b {
          width: 132px;
          padding: 14px 13px;
          line-height: 140%;
          padding-bottom: 10px;
          text-align: center;
          background: #f7f8fb;
          border-radius: 8px;
          display: block;
          margin: 0 auto;
          font-size: 15px;
          color: #6d7181;
        }
      }
    }
    .rightH3 {
      background: #ffffff;
      border-radius: 8px;
      padding: 30px;
      .rightH3Title {
        font-size: 18px;
        color: #191b27;
        padding-bottom: 20px;
        border-bottom: 1px solid #e7eaf0;
      }
      .rightH3Cont {
        padding: 30px 0 0 12px;
        .rightH3Item {
          display: flex;

          .itemRight {
            .title {
              font-size: 17px;
              color: #191b27;
              line-height: 100%;
              padding-bottom: 16px;
              padding-top: 4px;
            }
            .nodulus {
              font-size: 16px;
              font-weight: 500;
              color: #846ffd;
              padding-bottom: 12px;
              cursor: pointer;
            }
            .nodulus:hover {
              color: red;
            }
            .nodulus::before {
              content: "";
              display: inline-block;
              width: 6px;
              height: 6px;
              background: #846ffd;
              margin-right: 8px;
              border-radius: 50%;
              margin-top: -3px;
              vertical-align: middle;
            }
            .nodulus:hover::before {
              background: red;
            }
            .cont {
              font-size: 14px;
              color: #6d7181;
              margin-bottom: 10px;
              line-height: 160%;
              padding-left: 14px;
            }
            .recommend {
              font-size: 15px;
              color: #00c793;
              padding-bottom: 16px;
              padding-left: 14px;
              position: relative;
              cursor: pointer;
            }
            .recommend:hover {
              color: red;
            }
          }
        }
      }
    }
    .rightH4{
        background: #ffffff;
        border-radius: 8px;
        padding: 30px;
        margin-bottom: 20px;
        .rightH4Title{
          font-size: 18px;
          color: #191b27;
          padding-bottom: 20px;
          border-bottom: 1px solid #e7eaf0;
        }
        .rightH4Cont{
          padding-top: 20px; 
          .item{
            margin-bottom: 15px;
            display: flex;
            cursor: pointer;
            .title{
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 200px;
              display: block;
              line-height: 30px;
              font-weight: 100;
              font-size: 13px;
            }
            .new{
              padding: 0 5px;
              border-radius: 15px;
              background: red;
              color: #fff;
              font-size: 10px;
              line-height: 12px;
              height: 14px;
            }
          }
        }

    }
  }
  .imgTop {
    justify-content: space-between;
    display: flex;
    margin-bottom: 10px;
    .imgTopLeft {
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
    }
    .imgTopRight {
      height: 28px;
      line-height: 28px;
      padding: 0 15px;
      border: 1px solid #ddd;
      border-radius: 20px;
    }
  }
  .imgLabel {
    margin-bottom: 10px;
    .imgLabelItem {
      margin-right: 15px;
      font-size: 14px;
    }
  }
  .imgContH1 {
    .img {
      width: 100%;
    }
  }
  /deep/ .el-dialog {
    margin-top: 6vh;
  }

  .initialLogin {
    background: #ffebeb;
    border-radius: 8px 8px 8px 8px;
    line-height: 45px;
    padding: 0 20px 0 16px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    align-items: center;
    .initialLeft {
      color: #191b27;
      font-size: 15px;
      font-weight: 500;
    }
    .initialRight {
      height: 32px;
      width: 72px;
      background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      line-height: 32px;
      text-align: center;
      font-size: 13px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .statisticalBox {
    background: #ffffff;
    border-radius: 8px;
    padding: 17px 20px 26px 26px;
    margin-bottom: 12px;
    h1 {
      padding-bottom: 11px;
      border-bottom: 1px solid #e7eaf0;
    }
    .statisticalListBox {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      .statisticalItem {
        border-radius: 10px;
        width: 360px;
        display: block;
        height: 125px;
        position: relative;
        margin-bottom: 20px;
        margin-right: 17px;
        background: #fff6ed;
        cursor: pointer;

        // .img {
        //   position: absolute;
        //   width: 100%;
        //   height: 100%;
        //   left: 0;
        //   top: 0;
        //   opacity: 1;
        // }
        .name {
          font-size: 14px;
          color: #465069;
          padding-top: 35px;
          padding-bottom: 5px;
          line-height: 100%;
          padding-left: 130px;
        }
        .value {
          font-size: 30px;
          font-weight: 700;
          color: #191b27;
          line-height: 100%;
          padding-left: 130px;
          font-family: Akrobat-Bold, Akrobat;
        }
      }
      .feeItem {
        .name {
          padding-top: 20px;
        }
      }

      // .statisticalItem:nth-child(3n) {
      //   margin-right: 0;
      // }
    }
    .el-select .el-input.is-focus .el-input__inner {
      border: none;
    }
    .el-select .el-input__inner {
      border: none !important;
    }
  }
  .featureBox {
    background: #ffffff;
    border-radius: 8px;
    padding: 17px 20px 26px 26px;
    margin-bottom: 12px;
    h1 {
      padding-bottom: 11px;
      // border-bottom: 1px solid #e7eaf0;
    }
    .featureCont {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .featureItem {
        width: 280px;
        height: 104px;
        background: #f7f8fb;
        border-radius: 20px;
        margin-right: 20px;
        padding: 20px;
        cursor: pointer;
        margin-bottom: 20px;
        position: relative;
        .itemTop {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
   
          .ewm{
            display: block;
            width: 80px;
            height: 80px;
            background: red;
            margin-right: 15px;
          }
          .topRight {
            .itemName {
              font-size: 17px;
              color: #3d3d3d;
              margin-bottom: 10px;
              position: relative;
            }
            .itemValue {
              font-size: 14px;
              color: #999fb5;
            }
            .itemBtn{
              padding: 10px;
              border: 1px solid #ddd;
              text-align: center;
              margin-top: 10px;
            }
          }
        }
        .itemBottom {
          display: flex;
          margin-top: 15px;

          .btn {
            width: 82px;
            height: 36px;
            background: #ffffff;
            border-radius: 4px;
            margin-right: 10px;
            text-align: center;
            font-size: 14px;
            color: #191b27;
            line-height: 36px;
            cursor: pointer;
            position: relative;
          }
          .btn:hover {
            color: #846ffd;
          }
        }
      }

      .featureItem:hover {
        background: #f5f4ff;
      }
      // .featureItem:nth-child(3n) {
      //   margin-right: 0;
      // }
    }
  }
}

.questionIcon {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  margin-left: 10px;
}
.questionIcon:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}

.questionIcon2 {
  width: 19px;
  height: 19px;
  background-image: url("../../assets/new/questionIcon_a1.png");
  background-size: 19px 19px;
  vertical-align: middle;
  margin-top: -3px;
}
.questionIcon2:hover {
  background-image: url("../../assets/new/questionIcon_a2.png");
  background-size: 19px 19px;
}
/deep/ .statisticalItem .dongjie {
  padding-left: 120px;
  padding-top: 6px;
}
/deep/ .statisticalItem .feeName {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.RechargeBox {
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 40px;
  .rightH2Top {
    padding: 0 0 0 50px;
    // padding-bottom: 25px;
    // border-bottom: 1px solid #ddd;
    .rightH2a {
      line-height: 180%;
      font-size: 18px;
      color: #465069;
    }
  }
  .rightH2Bottom {
    // padding-top: 10px;
    margin-top: 25px;
    .rightH2b {
      width: 132px;
      padding: 14px 13px;
      line-height: 140%;
      padding-bottom: 10px;
      text-align: center;
      background: #f7f8fb;
      border-radius: 8px;
      display: block;
      margin: 0 auto;
      font-size: 15px;
      color: #6d7181;
    }
  }
}


/* 针对小屏幕设备（例如手机） */
@media (max-width: 600px) { 
  .home{
    min-width: 100%;
    display: block;
    padding: 16px;
    .contLeft{
      min-width: 100%;

      .statisticalItem{
        width: 100%!important;
        margin-right: 0!important;
      }
    }
    .contRight{
      width: 100%!important;
      

    }
  }

 


}
</style>
